var _defs, _g, _g2, _ellipse, _g3, _ellipse2, _polygon, _path, _polygon2, _polygon3, _path2, _path3, _g4, _path4, _ellipse3, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f07662;}.cls-2,.cls-3{fill:#fff;}.cls-4{fill:#e4e7ef;}.cls-5{fill:#fcdea3;}.cls-6{fill:#b3b3b3;}.cls-7{fill:#adb5c1;}.cls-8{fill:#ccc;}.cls-9{fill:#c9a86a;}.cls-10{fill:#dc624e;}.cls-11{fill:#e1e9ef;}.cls-12{fill:#4069b8;}.cls-13{fill:#646464;}.cls-14{fill:#4775cd;}.cls-15{mask:url(#mask-1);}.cls-15,.cls-16,.cls-17{fill:none;}.cls-16{mask:url(#mask);}.cls-17{mask:url(#mask-2-3);}.cls-3{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 23.37,
    y: 4.97,
    width: 14.38,
    height: 32.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-3",
    points: "37.75 37.8 23.37 37.8 23.37 4.97 37.75 4.97 37.75 37.8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 32.19,
    y: -0.07,
    width: 14.38,
    height: 32.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1-2",
    className: "cls-3",
    points: "46.57 32.76 32.19 32.76 32.19 -.07 46.57 -.07 46.57 32.76"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-3",
    x: 14.55,
    y: 10.01,
    width: 14.38,
    height: 32.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1-3",
    className: "cls-3",
    points: "28.93 42.84 14.55 42.84 14.55 10.01 28.93 10.01 28.93 42.84"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "m36.26,37.8l-8.32-4.47s-4.68-2.19-4.56-6.8V7.31s-.36-1.26,2.52-1.5c2.89-.24,2.4,1.26,2.4,1.26v18.33s-.04,2.16,1.84,3.12c1.88.96,7.53,4.12,7.53,4.12,0,0,.55,3.93-1.42,5.15"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    className: "cls-14",
    d: "m45.08,32.76l-8.32-4.47s-4.68-2.19-4.56-6.8V2.27s-.36-1.26,2.52-1.5c2.89-.24,2.4,1.26,2.4,1.26v18.33s-.04,2.16,1.84,3.12c1.88.96,7.53,4.12,7.53,4.12,0,0,.55,3.93-1.42,5.15"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 34.71,
    cy: 1.89,
    rx: 2.52,
    ry: 1.89
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    className: "cls-5",
    d: "m27.44,42.84l-8.32-4.47s-4.68-2.19-4.56-6.8V12.35s-.36-1.26,2.52-1.5c2.89-.24,2.4,1.26,2.4,1.26v18.33s-.04,2.16,1.84,3.12c1.88.96,7.53,4.12,7.53,4.12,0,0,.55,3.93-1.42,5.15"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 17.07,
    cy: 11.97,
    rx: 2.52,
    ry: 1.89
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "85.13 5.5 23.04 37 23.04 100 85.13 68.5 85.13 5.5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-6",
    d: "m72.16,58.42c-4.86,13.67-16.29,22.07-25.55,18.77-9.24-3.29-12.8-17.03-7.93-30.69,4.86-13.67,16.31-22.07,25.55-18.78,9.25,3.29,12.8,17.04,7.93,30.7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "23.04 100 19.3 98.1 19.3 35.17 23.04 37 23.04 100"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "85.13 5.5 23.04 37 19.3 35.17 82.26 4.04 85.13 5.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-13",
    d: "m49.96,57.44c-.98,2.75-3.27,4.43-5.13,3.77-1.86-.66-2.57-3.42-1.59-6.17.98-2.75,3.28-4.43,5.13-3.77,1.86.66,2.57,3.42,1.59,6.17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-13",
    d: "m64.3,49.77c-.89,2.5-2.98,4.04-4.68,3.44-1.69-.6-2.34-3.12-1.45-5.62.89-2.5,2.99-4.04,4.68-3.44,1.69.6,2.34,3.12,1.45,5.62"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m57.1,76.48c9.16-6.17,12.61-16.97,13.74-27.3.18-2.51-.06-4.99-.41-7.36-.37-3.27-1.07-6.51-2.96-9.21-.37-.56-1.18-1.58-1.72-2.02,0,0-.67-.62-.67-.62l-.76-.51c-2.03-1.4-4.69-2.11-7.53-2.06,2.69-.63,5.61-.53,8.14.64,8,3.56,10.04,13.53,9.22,21.47-.94,10.87-6.92,22.16-17.05,26.97h0Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m64.51,43.42l-10.47-4.15c-1.08-.39-2.42.59-2.98,2.18-.56,1.6-.15,3.2.92,3.57l9.55,3.83h0c4.55,2.06,6.03-.64,6.03-2.39,0-1.48-3.05-3.04-3.05-3.04Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 25.89,
    cy: 6.93,
    rx: 2.52,
    ry: 1.89
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.5,40.5c3.91.64,7.58,2,11,4-3.91-.66-7.59-1.97-11-4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricity);
export default __webpack_public_path__ + "static/media/electricity.2211ba6944e9bc8e09d9beaf4b005913.svg";
export { ForwardRef as ReactComponent };